import React from "react";
import "./BGMDeclineBanner.css";
import { useStoreState } from "easy-peasy";

const cardImages = ['/BGMDeclineBannerCard-1.png', '/BGMDeclineBannerCard-2.png', '/BGMDeclineBannerCard-3.png']

function BGMDeclineBanner() {

  const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);

  const bannerContent = productSettings?.AdditionalContent?.BGMDeclineBanner;
  const bannerTexts = Array.isArray(bannerContent) ? bannerContent : [];

  const getBannerText = sequence =>
    bannerTexts.find(item => Number(item.Sequence) === sequence)?.Text ?? "";

  const bannerTitle = getBannerText(1);
  const bannerSubtitle = getBannerText(2);
  const bannerCTA = getBannerText(3);
  const bannerFinePrint = getBannerText(4);

  return (
    <section
      className="bgm-decline-banner"
      aria-labelledby="bgm-decline-banner-title"
    >
      <div className="bgm-decline-banner__content">
        <h2 id="bgm-decline-banner-title">{bannerTitle}</h2>
        <p className="bgm-decline-banner__subtitle">
          {bannerSubtitle}
        </p>

        <div className="bgm-decline-banner__cards">
          {cardImages.map((imageUrl, index) => (
            <img
              key={`${imageUrl}-${index}`}
              className="bgm-decline-banner__card"
              src={imageUrl}
              alt=""
            />
          ))}
        </div>

        <a
          className="bgm-decline-banner__cta"
          href='https://www.creditsoup.com/'
        >
          {bannerCTA}
        </a>

        <p className="bgm-decline-banner__disclaimer">
          {bannerFinePrint}
        </p>
      </div>
    </section>
  );
}

export default BGMDeclineBanner;
